import React from 'react';
import CircularProgress from 'material-ui/Progress/CircularProgress';
import Session from '../calendar/components/Session';
import InstructionVisibilityContext from './InstructionVisibilityContext';
import FullScreenHeader from './FullScreenHeader';
import useFullScreenWorkout from './useFullScreenWorkout';

const FullScreenWorkoutView = ({ match }) => {
    const { session, isLoading } = useFullScreenWorkout(
        match.params.programWorkoutId
    );

    return (
        <InstructionVisibilityContext.Provider value={!isLoading}>
            <div className="fullscreen-workout">
                <FullScreenHeader isLoading={isLoading} session={session} />
                <div
                    className={
                        isLoading
                            ? 'fullscreen-workout-content loading'
                            : 'fullscreen-workout-content'
                    }
                >
                    {isLoading ? (
                        <CircularProgress
                            style={{ height: 48, width: 48, color: '#999' }}
                        />
                    ) : (
                        <Session session={session} isPreview={true} />
                    )}
                </div>
            </div>
        </InstructionVisibilityContext.Provider>
    );
};

export default FullScreenWorkoutView;



// WEBPACK FOOTER //
// ./src/view/fullScreenWorkout/FullScreenWorkoutView.jsx